export enum ExternalRegistrationStep {
    Incomplete = 1,
    AwaitingReview = 2,
    Complete = 3
}